export default __webpack_public_path__ + "static/media/freeCodeCamp Responsive Web Design.3d4fa906.webp";